import api from "../api";

export async function gerarBoleto(dadosBoleto = null) {
    try {
        const response = await api.post("/boleto/gerar", dadosBoleto, {
            headers: {
                "Content-Type": "application/json"
            },
            responseType: "blob",
            validateStatus: function (status) {
                return status < 500;
            }
        });

        if (response.status === 201) {
            const boletoCloudVersion = response.headers["x-boletocloud-version"];
            const boletoCloudToken = response.headers["x-boletocloud-token"];
            const location = response.headers["location"];

            return {
                sucesso: true,
                pdf: response.data,
                versao: boletoCloudVersion,
                token: boletoCloudToken,
                localizacao: location
            };
        } else {
            let erro;
            try {
                const textoErro = await response.data.text();
                erro = JSON.parse(textoErro);
            } catch {
                erro = "Erro desconhecido";
            }

            return { sucesso: false, codigoHttp: response.status, erro: erro };
        }

    } catch (error) {
        if (error.response) {
            let erroResposta;
            try {
                const textoErro = await error.response.data.text();
                erroResposta = JSON.parse(textoErro);
            } catch {
                erroResposta = "Erro na resposta da API";
            }

            return { sucesso: false, codigoHttp: error.response.status, erro: erroResposta };
        } else if (error.request) {
            return { sucesso: false, erro: "Erro de conexão com o servidor" };
        } else {
            return { sucesso: false, erro: error.message };
        }
    }
}

export function baixarPDF(pdfBlob, nomeArquivo = "boleto.pdf") {
    const url = window.URL.createObjectURL(pdfBlob);
    const link = document.createElement("a");
    link.href = url;
    link.download = nomeArquivo;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
}

export function visualizarPDF(pdfBlob) {
    const url = window.URL.createObjectURL(pdfBlob);
    window.open(url, "_blank");
}